import { createLog } from '../utils/logger'
import { TCString } from '@iabtcf/core'

const log = createLog()

function chooseTcString (tcStringFromClient, addtlConsentFromClient, currentRepromptVersionFromClient, nextRepromptVersionFromClient, tcDataFromStorage) {
  const { tcString: tcStringFromStorage = undefined, addtlConsent: addtlConsentFromStorage = undefined, repromptVersion: repromptVersionFromStorage = 0 } = tcDataFromStorage || {}
  const repromptVersion = Math.max(currentRepromptVersionFromClient, repromptVersionFromStorage)
  const nextRepromptVersion = Math.max(repromptVersion, nextRepromptVersionFromClient)
  log('nextRepromptVersion', nextRepromptVersion)
  const storedStrings = { tcString: tcStringFromStorage, addtlConsent: addtlConsentFromStorage, source: 'localStorage', repromptVersion, nextRepromptVersion }
  const clientStrings = { tcString: tcStringFromClient, addtlConsent: addtlConsentFromClient, source: 'client', repromptVersion, nextRepromptVersion }
  log('clientString', tcStringFromClient)
  log('storedString', tcStringFromStorage)
  const selectStrings = () => {
    const stored = TCString.decode(tcStringFromStorage).lastUpdated
    const client = TCString.decode(tcStringFromClient).lastUpdated
    log('stored', stored)
    log('client', client)
    return stored > client ? storedStrings : clientStrings
  }

  if (tcStringFromClient && tcStringFromStorage) {
    return selectStrings()
  } else if (tcStringFromClient) {
    return clientStrings
  } else {
    return storedStrings
  }
}

function getCustomVendorConsents (customVendorsFromClient, customVendorsFromStorage, source) {
  const clientConsents = customVendorsFromClient && customVendorsFromClient.consents || {}
  const storageConsents = customVendorsFromStorage && customVendorsFromStorage.consents || {}
  return source === 'client' ? clientConsents : storageConsents
}

export class Config {
  constructor (config) {
    this.config = config
  }

  getGVLVersions (tcString) {
    const { vendorListVersion } = tcString && TCString.decode(tcString) || {}
    log('gvlVersion from tcString', vendorListVersion)
    let gvlUiVersion = parseInt(this.config.gvlUiVersion)
    const gvlVersion = vendorListVersion || gvlUiVersion
    gvlUiVersion = Math.max(gvlVersion, gvlUiVersion)
    log('selected gvlVersions', { gvlVersion, gvlUiVersion })
    return { gvlVersion, gvlUiVersion }
  }

  getUserPreferences (tcData, customVendors) {
    const { tcString, addtlConsent, source, repromptVersion, nextRepromptVersion } = chooseTcString(this.config.tcString, this.config.addtlConsent, this.config.repromptVersion, this.config.nextRepromptVersion, tcData)
    const consentStrings = { tcString, addtlConsent, repromptVersion, nextRepromptVersion }
    if (!consentStrings.addtlConsent) {
      log('no addtlConsent string, trying customVendorConsents')
      consentStrings.customVendorConsents = getCustomVendorConsents(this.config.customVendors, customVendors, source)
    } else {
      log('using addtlConsent string')
    }

    return consentStrings
  }

  get (key) {
    if (key && Object.prototype.hasOwnProperty.call(this.config, key)) {
      return this.config[key]
    } else {
      return this.config
    }
  }
}

export function createConfig () {
  const scriptTag = document.getElementById('mol-ads-tcfv2-script')
  const config = JSON.parse(scriptTag.dataset.opts || {})
  log('config', config)
  return new Config(config)
}
